/**
 * The nav badge's number: how many family requests await the clinic. It is
 * the `total` the requests read already carries — no extra backend work and
 * no polling: fetched on load and window focus, and invalidated by every
 * family write. Absent without families.read.
 */

import { useQuery } from '@tanstack/react-query';
import { listFamilyRequests } from '@/core/clinic/familyApi';
import { useAuthz } from '@/core/authz/AuthzProvider';
import { PERM } from '@/core/authz/permissions';
import { familyKey } from './familyShared';

export function usePendingRequestsCount(): number | null {
  const authz = useAuthz();
  const enabled = authz.clinicId !== null && authz.can(PERM.familiesRead);
  const q = useQuery({
    queryKey: familyKey.requests(authz.clinicId),
    queryFn: () => listFamilyRequests(),
    enabled,
    staleTime: 60_000,
    retry: false,
  });
  return enabled && q.data ? q.data.total : null;
}
